import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as FileAttachmentsActions from '../actions/fileattachments.actions';
import { MessageService } from 'primeng/api';
import { ApiConstants } from 'src/app/base/api-constants';

@Injectable()
export class FileAttachmentsEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);

  //   Get File Attachments Data
  getFileAttachmentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FileAttachmentsActions.getFileAttachments),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(
                FileAttachmentsActions.setFileAttachments({
                  fileAttachmentsDataOrder: result
                })
              );
            } else {
              this.store.dispatch(
                FileAttachmentsActions.setFileAttachments({
                  fileAttachmentsDataOrder: { orders: null }
                })
              );
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getFileAttachmentsItemsWithSorting$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FileAttachmentsActions.getFileAttachmentsWithSorting),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe(
            (result: any) => {
              if (result) {
                this.store.dispatch(
                  FileAttachmentsActions.setFileAttachments({
                    fileAttachmentsDataOrder: result
                  })
                );
              } else {
                this.store.dispatch(
                  FileAttachmentsActions.setFileAttachments({
                    fileAttachmentsDataOrder: { orders: null }
                  })
                );
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  //   Save File Attachments Data
  saveFileAttachmentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FileAttachmentsActions.saveFileAttachments),
        map((action: any) => {
          console.log(action);
          if (action.actionType === 'Delete') {
            const apiConstants = { ...action.saveapiConstants };
            apiConstants.url = `${action.saveapiConstants.url}/${action.sidToBeSent}`;
            return this.baseService[action.saveapiConstants?.method](
              apiConstants,
              action.fileAttachmentsData
            ).subscribe((_menuData: any) => {
              if (action.actionType === 'Delete') {
                this.showMessage('success', 'Deleted Successfully!');
              }
            });
          }
          return this.baseService[action.saveapiConstants?.method](
            action.saveapiConstants,
            action.fileAttachmentsData
          ).subscribe((_menuData: any) => {
            if (action.actionType === 'Delete') {
              this.showMessage('success', 'Deleted Successfully!');
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );

  saveFileAttachmentsItemsForOrder$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FileAttachmentsActions.saveFileAttachmentsForOrder),
        map((action: any) => {
          console.log(action);
          if (action.actionType === 'Delete' && action.itemType === 'attachment') {
            const apiConstants = { ...action.saveapiConstants };
            apiConstants.url = `${action.saveapiConstants.url}/${action.itemType}/${action.sidToBeSent}`;
            return this.baseService[action.saveapiConstants?.method](
              apiConstants,
              action.fileAttachmentsData
            ).subscribe((_menuData: any) => {
              if (action.actionType === 'Delete') {
                this.showMessage('success', 'Deleted Successfully!');
              }
            });
          }
          return this.baseService[action.saveapiConstants?.method](
            action.saveapiConstants,
            action.fileAttachmentsData
          ).subscribe((_menuData: any) => {
            if (action.actionType === 'Delete') {
              this.showMessage('success', 'Deleted Successfully!');
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );

  // Delete FileAttachment Data
  deleteFileAttachmentsItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FileAttachmentsActions.deleteFileAttachments),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.fileAttachmentsId;

          return this.baseService[action.apiConstants?.method](apiConstants).subscribe((menuData: any) => {
            this.store.dispatch(
              FileAttachmentsActions.getFileAttachments({
                apiConstants: ApiConstants.getFileAttachmentsDataOrder
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );
  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
